import React, { Component, Fragment } from 'react'
import { Navbar, Nav } from 'react-bootstrap'
import logoSmall from '../../asset/image/logo-small.png';
import '../../asset/css/custom.css';
import '../../asset/css/responsive.css';
import '../../asset/css/bootstrap.min.css';
import { NavLink } from "react-router-dom"

class TopNavigation extends Component {

     constructor(props) {
          super();
          this.state = {
               navBarTitle: "navTitle",
               navBarLogo: logoSmall,
               navVariant: "dark",
               navBarBack: "navBackground",
               navBarItem: "navItem",
               pageTitle: props.title
          }
     }

     onScroll = () => {
          if (window.scrollY > 100) {
               this.setState({ navBarTitle: 'navTitleScroll', navBarLogo: logoSmall, navBarBack: 'navBackgroundScroll', navBarItem: 'navItemScroll', navVariant: 'light' })

          } else if (window.scrollY < 100) {

               this.setState({ navBarTitle: 'navTitle', navBarLogo: logoSmall, navBarBack: 'navBackground', navBarItem: 'navItem', navVariant: 'dark' })
          }
     }

     componentDidMount() {
          window.addEventListener('scroll', this.onScroll)
     }


     render() {
          const textColor = this.state.navVariant === 'dark' ? '#fff' : '#000';

          return (
               <Fragment>
                    <title>{this.state.pageTitle}</title>
                    <Navbar className={this.state.navBarBack} collapseOnSelect fixed="top" expand="lg" variant={this.state.navVariant}>
                         <Navbar.Brand className={this.state.navBarTitle} >
                              <NavLink to="/" className="softEngineBrand" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
                                   <img className="softEngineLogo" src={this.state.navBarLogo} alt="Logo" width="60" height="60" />
                                   <span className="softEngineText" style={{ color: textColor, fontWeight: '700', fontSize: '20px' }}>Soft Engine BD</span>
                              </NavLink>
                         </Navbar.Brand>
                         <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                         <Navbar.Collapse id="responsive-navbar-nav">
                              <Nav className="mr-auto">

                              </Nav>
                              <Nav>
                                   <Nav.Link> <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/">HOME</NavLink> </Nav.Link>

                                   <Nav.Link> <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/about">ABOUT</NavLink> </Nav.Link>

                                   <Nav.Link>  <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/service">SERVICE</NavLink> </Nav.Link>

                                   <Nav.Link>  <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/product">PRODUCTS</NavLink> </Nav.Link>

                                   <Nav.Link>  <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/porfolio">PORTFOLIO</NavLink> </Nav.Link>

                                   <Nav.Link>  <NavLink exact activeStyle={{ color: '#ffd900' }} className={this.state.navBarItem} to="/contact">CONTACT US</NavLink> </Nav.Link>
                                   
                                


                              </Nav>
                         </Navbar.Collapse>
                    </Navbar>

               </Fragment>
          )
     }
}

export default TopNavigation
